import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, Checkbox, Card, Badge, Dialog, VisuallyHidden, Separator} from '@radix-ui/themes';
import { ChevronRightIcon, ChevronLeftIcon, DotIcon, DotFilledIcon } from '@radix-ui/react-icons';
import { ThickCheckIcon } from '@radix-ui/themes';
import aiService from '../../../services/aiService';
import { toast } from 'react-toastify';
import Carousel from '../../carousel/Carousel';
import { v4 as uuidv4 } from 'uuid';
import { COMPETENCY_COLORS } from '../../../utils/constants';
import { CheckIcon } from '@radix-ui/react-icons';
import { quizService } from '../../../services/quizService';
import LoadingIndicator from '../../shared/LoadingIndicator';
import EditQuestion from './EditQuestion';
import AIQuestionsSettings from './AIQuestionsSettings';
import { current } from '@reduxjs/toolkit';

const QuestionsPicker = ({ course, quizType, prevQuestions, topics = [], prevSelection = [], onCancel, onComplete }) => {
    const [selectedQuestions, setSelectedQuestions] = useState(prevSelection || []); //ids
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [generated, setGenerated] = useState(false);
    const [questions, setQuestions] = useState(prevQuestions || []);
    const [aiGeneration, setAiGeneration] = useState({status:'inactive', count:0, settings:{difficulty:'medium', ratios:{vocabulary: 33, concept: 33, application: 34}}});
    const [showCustomQuestion, setShowCustomQuestion] = useState(false);

    console.log('TOPICS', topics);


    const generateQuestions = async () => {
        setLoading(true);
        try {
            // if (topics.length === 0) {
            //     toast.error('Please select at least one topic');
            //     setLoading(false);
            //     return;
            // }

            // reduce parameters to course id and topics
            const aiResponse = await aiService.generateQuestions({
                course_id: course.id,
                topics: topics.map(topic => topic.id),
                difficulty: aiGeneration.settings.difficulty,
                recommended_ratio: aiGeneration.settings.ratios,
                excludes:questions.map(question => question.id)
            });

            console.log('aiResponse', aiResponse);
            if(aiResponse.error){
                console.warning('error generating questions', aiResponse.error);
                toast.error(aiResponse.error);
                return;
            }

            // Extract JSON from markdown code block
            // const jsonMatch = aiResponse.match(/```json\n([\s\S]*?)\n```/);
            // const jsonString = jsonMatch ? jsonMatch[1] : null;

            // if (!jsonString) {
            //     throw new Error('Invalid AI response format');
            // }

            // const response = JSON.parse(jsonString);

            const ai_questions = aiResponse.map(question => ({
                ...question,
                core_competencies:JSON.parse(question.core_competencies),
                source:'ai'
            }));

            setQuestions(prev => [...prev, ...ai_questions]);

            console.log('questions', questions);
            setAiGeneration(prev => ({...prev, count:prev.count + 1}))
            // setStep(3);
        } catch (error) {
            console.error('Error generating questions:', error.message);
            toast.error('Error generating questions. Please try again.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if(questions.length === 0) {
            getQuestions();
        } else {
            setLoading(false);
        }
    }, [])

    const getQuestions = async () => {
        const limit = questions.length < 5 ? 15 : 10;
        setLoading(true);
        try{
            const response_data = await quizService.getQuestions({
                topics:topics.map(topic => topic.id),
                exclude:questions.map(question => question.id) || [],
                limit:limit
            })
            console.log('response_data', response_data)
            if(response_data.error){
                console.log('error', response_data.error);
                toast.error(response_data.error);
            } else {
                const res_questions = response_data.map(question => ({
                    ...question,
                    core_competencies:JSON.parse(question.core_competencies),
                    source:'db'
                }));

                // because strict mode duplicates the requests I have to make sure the ids are not repeated
                setQuestions((prev) => {
                    const newQuestions = res_questions.filter(question => !prev.some(q => q.id === question.id));
                    return [
                        ...prev,
                        ...newQuestions
                    ];
                });
                console.log('LIMIT', limit)
                if(res_questions.length < limit && aiGeneration.status != 'active'){
                    console.log('INSIDE THE CHECK')
                    setAiGeneration(prev => ({...prev, status:'active'}))
                }
            }
        } catch(error) {
            console.error('Error getting questions:', error);
        } finally {
            setLoading(false);
        }
    }



    useEffect(() => {
        console.log('generation tracking>>>>>>>>>>>>>>>>>>>>>>', aiGeneration);
    }, [aiGeneration])

    const handleQuestionToggle = (questionId) => {
        console.log('Toggling question:', questionId);
        const updatedSelection = selectedQuestions.includes(questionId)
            ? selectedQuestions.filter((id) => id !== questionId)
            : [...selectedQuestions, questionId];

        setSelectedQuestions(updatedSelection);
        // onSelectionChange(updatedSelection);
    };

    

    const handleSelectQuestionByIndex = (index) => {
        setCurrentQuestionIndex(index);
        const question = questions[index];
        if (selectedQuestions.some(qid => qid === question.id)) {
            setSelectedQuestions((prev) => prev.filter(id => id !== question.id))
        } else {
            selectedQuestions.push(question.id);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    }

    const handleSelectionConfirm = () => {
        console.log('Selected questions:', selectedQuestions);
        onComplete(questions, selectedQuestions);
    }

    const questionSaved = (question) => {
        const new_question = {...question, core_competencies:JSON.parse(question.core_competencies)}
        setQuestions(prevQuestions => (
            [...prevQuestions, new_question]
        ));
        selectedQuestions.push(question.id);
        setShowCustomQuestion(false)
    }

    const handleAISettingComplete = (settings) => {
        console.log('settings', settings);
        setAiGeneration(prev => ({...prev, settings:settings}))
        generateQuestions();
    }

    const renderShortAnswer = (answer) => {
        const rubric = JSON.parse(answer.rubric);
        return (
            <Flex direction="column" gap="2">
                <Text size="2" weight="bold">Example Correct Answer</Text>
                <Text size="2" color="green">{answer.text}</Text>
                {/* <Text size="2" weight="bold">Rubric</Text>
                <Text size="1" weight="bold">Full Credit</Text>
                <Text size="1">{rubric.full_credit}</Text>
                <Text size="1" weight="bold">Partial Credit</Text>
                <Text size="1">{rubric.partial_credit}</Text>
                <Text size="1" weight="bold">No Credit</Text>
                <Text size="1">{rubric.no_credit}</Text> */}
            </Flex>
        )
    }


    const renderQuestionCard = (question, index) => {
        const isSelected = selectedQuestions?.some(qid => qid === question.id);
        return (
            <Card
                key={question.id}
                onClick={() => handleQuestionToggle(question.id)}
                style={{
                    cursor: 'pointer',
                    height:'100%',
                    minHeight: '400px',
                    maxHeight:'600px',
                    width: '100%',  
                    border: isSelected
                        ? '2px solid green'
                        : '1px solid var(--gray-5)'
                }}
            >
            
                <Flex justify="between" gap="2" wrap="wrap" mb="2">
                    <Flex direction="row" gap="2" align="center" justify="start" style={{flex:1}}>
                    <Text weight="bold">{index + 1}</Text>
                    {question.core_competencies?.map((competency, index) => (
                            <Badge
                                key={index}
                                variant="solid"
                                radius="full"
                                color={
                                    COMPETENCY_COLORS[competency] || 'gray'
                                }
                            >
                                {competency}
                            </Badge>
                        ))}
                        </Flex>
                        {isSelected && (<ThickCheckIcon width="15px" height="15px" color="green" />)}
                </Flex>
                <Flex direction="column" gap="3">
                    <Text size="2" mb="4">{question.text}</Text>

                    <Flex direction="column" gap="2" mb="4">
                        {question.type == 'multiple_choice' && question.answers.map((answer, index) => (
                            <Text
                                key={index}
                                size="2"
                                color={answer.is_correct ? 'green' : 'gray'}
                                weight={answer.is_correct ? 'bold' : 'normal'}
                            >
                                {index + 1}. {answer.text}
                            </Text>
                        ))}
                        {question.type == 'short_answer' && (
                            renderShortAnswer(question.answers[0])
                        )}
                    </Flex>
                    <Text size="2" weight="bold">Explanation</Text>
                    <Text size="1" color="gray">{question.explanation}</Text>
                </Flex>
        </Card>
        )
    }

    if(loading) {
        return (
            <Box width="100%" height="100%" justify="center" align="center">
                <LoadingIndicator text="Processing..." />
            </Box>)
    }

    return (
        <Box>
            <Flex gap="4">
            <Flex justify="between" align="center" maxWidth="100px" width="100%">
                <Text size="1" >Selected</Text>
                <Badge>{selectedQuestions.length}</Badge>
            </Flex>
            <Flex justify="between" align="center" maxWidth="100px" width="100%">
                <Text size="1" >Questions</Text>
                <Badge>{questions.length}</Badge>
            </Flex>
            </Flex>
            <Box py="2" style={{position:'relative'}}>
                <Carousel currentIndex={currentQuestionIndex} onIndexChange={setCurrentQuestionIndex} disableControls={true}>
                    {questions.map((question, index) => (
                        renderQuestionCard(question, index)
                    ))}
                    <Card
                    style={{height:'100%',
                    minHeight: '400px',
                    maxHeight:'600px',
                    width: '100%'}}  >
                        <Flex direction="column" justify="center" align="center" gap="4" width="100%" height="100%">
                            {(aiGeneration.count < 3 && aiGeneration.status == 'active') ? (
                                // <Flex direction="column" gap="2" justify="center" align="center">
                                //     <Text size="1">Let AI generate more questions</Text>
                                //     <Button size="1" color="orange" onClick={() => generateQuestions()}>AI Generate</Button>
                                // </Flex>
                                <AIQuestionsSettings course={course} topics={topics} onComplete={handleAISettingComplete} />
                            ):(
                            <Flex direction="column" gap="2" justify="center" align="center">
                                <Text size="1">Get more questions</Text>
                                <Button size="1" onClick={() => getQuestions()}>More Questions</Button>
                            </Flex>
                            )}
                            <Separator size="3" />
                            <Flex direction="column" gap="2" justify="center" align="center">
                                <Text size="1">You can create your own question</Text>
                                <Button size="1" onClick={() => setShowCustomQuestion(true)}>Add Custom Question</Button>
                            </Flex>
                            <Separator size="3" />
                        </Flex>
                    </Card>
                </Carousel>
                <Flex gap="2" justify="center" align="center" mb="2" px="4" width="100%" style={{position:'absolute', bottom:'10px', zIndex:'100', flexWrap:'wrap'}}>
                    {questions.map((question, index) => (
                        <div key={index} 
                        style={{
                            cursor:'pointer', 
                            width:'8px', 
                            height:currentQuestionIndex == index ? '16px' : '8px', 
                            borderRadius:'30%', 
                            backgroundColor:selectedQuestions.includes(question.id) ? 'var(--accent-9)' : 'var(--accent-3)',
                            transform: currentQuestionIndex == index ? 'translateY(-3px)' : 'none'
                        }} 
                        onClick={() => setCurrentQuestionIndex(index)} />
                    ))}
                </Flex>
            </Box>
            <Flex direction="row" gap="4" justify="between" align="center">
                <Flex gap="2" justify="center" align="center">
                    <Button variant="soft" size="2" onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)} disabled={currentQuestionIndex === 0}>
                        <ChevronLeftIcon />
                    </Button>
                    <Button variant="solid" size="2" onClick={() => handleSelectQuestionByIndex(currentQuestionIndex)} disabled={currentQuestionIndex > questions.length - 1}>
                        Select
                    </Button>
                    <Button variant="soft" size="2" onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)} disabled={currentQuestionIndex === questions.length}>
                        <ChevronRightIcon />
                    </Button>
                </Flex>
                <Button onClick={handleSelectionConfirm} disabled={selectedQuestions.length === 0}>
                    <CheckIcon width="15px" height="15px" />
                    Confirm
                </Button>
            </Flex>
            

            <Dialog.Root open={showCustomQuestion}>
                <Dialog.Content size="1" maxWidth="350px">
                    <VisuallyHidden><Dialog.Title>Add Custom Question</Dialog.Title></VisuallyHidden>
                    <EditQuestion onSave={questionSaved} onCancel={() => setShowCustomQuestion(false)} topics={topics}/>
                </Dialog.Content>
            </Dialog.Root>
        </Box>
    );
};

export default QuestionsPicker;